module.exports = __webpack_public_path__ + "942635881a0a3f3293d96d59f19c9285.svg";